export default __webpack_public_path__ + "static/media/login-icon-3047.18c3cf36.png";